import React from "react";

import PhotoModLargeUploadImage from "../PhotoModLargeUploadImage";

import { useSlideshow } from "frontend/components/core/Slideshow";

const PhotoModCarouselImage = ({ uploadId }) => {
    const { current, next, previous } = useSlideshow();

    const loadImage =
        current === uploadId || next === uploadId || previous === uploadId;

    return (
        <PhotoModLargeUploadImage uploadId={uploadId} loadImage={loadImage} />
    );
};

export default PhotoModCarouselImage;
